import { createFileRoute, redirect } from '@tanstack/react-router'

// Facilities settings moved to the Houses page; bookmarks and old links land there.
export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/facilities'
)({
  beforeLoad: () => {
    throw redirect({ to: '/houses', replace: true })
  },
})
